import { fluidBreakpoints } from '@/utils/sizes';
import { TComponentMarginBottom } from '@/types/global';
import { ElementType } from 'react';

export const roundNum = (num: number, decimals: number = 2): number => {
  const factor = Math.pow(10, decimals);
  return Math.round(num * factor) / factor;
};

export const generateClampFromMinMax = (
  minPx: number,
  maxPx: number,
  maxBreakpoint = fluidBreakpoints.max,
  minBreakpoint = fluidBreakpoints.min
) => {
  const slope = (maxPx - minPx) / (maxBreakpoint - minBreakpoint);
  const vwValue = slope * 100;
  const intercept = minPx - slope * minBreakpoint; // Adjusts the starting point

  return `clamp(${minPx}px, ${intercept.toFixed(2)}px + ${vwValue.toFixed(2)}vw, ${maxPx}px)`;
};

export const generateClampFromMax = (maxPx: number) => {
  const proportion = fluidBreakpoints.min / fluidBreakpoints.max;
  const minPx = maxPx * proportion;
  const slope = (maxPx - minPx) / (fluidBreakpoints.max - fluidBreakpoints.min);
  const vwValue = slope * 100;
  return `clamp(${roundNum(minPx)}px, ${roundNum(vwValue)}vw, ${roundNum(maxPx)}px)`;
};

export const isStyledComponent = (Component?: ElementType) => {
  return (
    Component &&
    typeof Component === 'object' &&
    'styledComponentId' in Component
  );
};

export const getComponenentSeparation = (
  margin: TComponentMarginBottom
  // isProject: boolean
) => {
  if (margin === 'none') return '0';
  else if (margin !== 'default') return `var(--spacing-component-${margin})`;
  else if (margin === 'default') {
    return 'var(--spacing-component)';
  }
  return 'var(--spacing-component)';
};

export const getMaxWidthWithPadding = (
  width: number,
  paddingProportion: number
) => {
  return `${(paddingProportion / 100) * width + width}px`;
};

export const getContentJustifyVal = (
  contentJustify: 'top' | 'center' | 'bottom'
) => {
  return contentJustify === 'top'
    ? 'flex-start'
    : contentJustify === 'center'
      ? 'center'
      : 'flex-end';
};

export const getProportionateVwPadding = (
  containerWidth: number,
  contentWidth: number
): string => {
  const prefered = ((containerWidth - contentWidth) / 2 / containerWidth) * 100;
  const minValPx = fluidBreakpoints.min * (prefered / 100);
  const maxValPx = fluidBreakpoints.max * (prefered / 100);

  return `clamp(${roundNum(minValPx)}px, ${roundNum(prefered)}vw, ${roundNum(maxValPx)}px)`;
};

export const stripUnit = (value: string): number => {
  const match = value.match(/^(-?\d+(\.\d+)?)/);
  return match ? parseFloat(match[0]) : parseFloat(value) || 0;
};
